module.exports = __webpack_public_path__ + "img/customer_small@2x.b08a0a28.webp";